
import styled from "styled-components";
import { system } from "styled-system";

export default styled.svg.withConfig({
  shouldForwardProp: (prop) => true,
})`
  ${system({
    color: {
      property: "color",
      scale: "colors",
    }
  })}
`;
